<template>
    <div class="package orders">
        <div class="box-white-wrapper" v-if="dispatchOrden.notes != undefined">
            
            <div class="wrap-box order-wrap">
                
                <a href="/orders" class="viewBill">Regresar</a>
        
                <div class="item">
                    <div class="head">
                        <div class="icon">
                            <img src="@/assets/images/package.png" alt="" class="img-fluid">
                        </div>
                        <div class="subTitle">Solicitud de despacho</div>
                    </div>
                    <div class="detail">
                        <h3>Fecha Solicitud:</h3>
                        <p>{{ dispatchOrden.createdAt | moment('DD/MM/YYYY') }}</p>
                    </div>
                    <div class="detail">
                        <h3>Solicitante:</h3>
                        <p>{{ dispatchOrden.applicantUser.name +" "+dispatchOrden.applicantUser.lastname}}</p>
                    </div>
                    <div class="detail">
                        <h3>Nombre:</h3>
                        <p>{{ dispatchOrden.notes}}</p>
                    </div>
                    <div class="detail changeStatus">
                        <h3>Estado:</h3>
                        <p @click="changeDispatchStatus()">{{ dispatchOrden.statusName}} <vs-icon icon="refresh"></vs-icon></p>
                    </div>
                </div>
            </div>

            <div class="title">Listado de paquetes</div>
            <div class="order-table">
              <vs-table :data="dispatchOrden.detail" pagination search max-items="50" id="josue">
                  <template slot="header">
                      <div class="extra-actions">
                        <div v-if="userInfoData.role == Roles.Admin">
                          <vs-button id="btnDownloadPacks" class="vs-con-loading__container" @click="downloadPackagesReport" color="primary" 
                            type="border" icon="cloud_download">Descargar</vs-button>
                          <vs-button color="primary" type="border" icon="send" @click="activeSendReport = true" class="ml-10">Enviar</vs-button>
                        </div>
                        <vs-button color="primary" type="border" icon="print" @click="exportOrderDetail" class="ml-10">Imprimir</vs-button>
                      </div>
                  </template>
                  <template slot="thead">
                      <vs-th sort-key="customerName">Name</vs-th>
                      <vs-th sort-key="tracking">Tracking </vs-th>
                      <vs-th sort-key="inv02Code">Location </vs-th>
                      <vs-th sort-key="weight" class="center"> Weight </vs-th>
                  </template>
                  <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                          <vs-td :data="data[indextr].customerName">{{data[indextr].inventory?.customerName}}</vs-td>
                          <vs-td :data="data[indextr].tracking">{{data[indextr].inventory?.id }}</vs-td>
                          <vs-td :data="data[indextr].inv02Code">{{data[indextr].inventory?.inv02Code }}</vs-td>
                          <vs-td :data="data[indextr].weight" class="center">{{data[indextr].inventory?.weight }} lb</vs-td>
                      </vs-tr>
                  </template>
              </vs-table>
            </div>
        </div>
        
        <modalDispatch @modal-event="handleActionModalPackage" :packID="packageId" :modeUdpdate="typeChangeSt" 
          :selected="pkgCurrentStatus" :show="modalActive"></modalDispatch>

        <vs-prompt title="Envió de datos" color="" accept-text="Enviar" cancel-text="Cancelar" @accept="confirmToSent"  @close="closedModaSendReport()" 
          @cancel="closedModaSendReport()" :active="activeSendReport" :buttons-hidden="buttonsHidden">
          <div class="recovery form">
            <div class="form-input">
              <vs-input label="Correo Electrónico" v-model="sendEmail"/>
            </div>
            <div class="form-input">
              <vs-input label="Cc." v-model="sendCC"/>
              <br v-if="buttonsHidden">
              <p v-if="buttonsHidden">Procesando.. Espero un momento</p>
            </div>
          </div>
        </vs-prompt>

    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import InventoryService from "@/services/InventoryService"
import ModalDispatch from '@/components/Modal/DispatchStatus.vue'
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
export default {
  name: 'OrderDetail',
  mixins: [helper],
  components: { ModalDispatch },
  data () {
    return {
      dispatchOrden: {},
      typeChangeSt: false,
      packageId: "",
      pkgCurrentStatus:{ id: 2, name: "PreAlerta"},
      modalActive: false,
      dispatchId: "",
      sendEmail: "",
      sendCC: '',
      buttonsHidden: false,
      activeSendReport: false,
      
    }
  },
  created(){
    this.Roles = Role
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.getDispatchDetail(this.$route.params.id);
  },
  methods: {
    exportOrderDetail() {
      let doc = new jsPDF()
      doc.setFont("helvetica");
      doc.setFontSize(14);

      var img = new Image()
      img.src = require('@/assets/images/logo.png');
      const pageWidth = doc.internal.pageSize.width; // pdf page width
      doc.addImage(img, 'png', pageWidth -50, 10, 35, 15)
      doc.setFont(undefined, "", "bold");
      doc.text("Order #:", 14, 35);
      doc.setFont(undefined, "", "normal");
      doc.text(this.dispatchId, 35, 35);
      
      
      doc.setFont(undefined, "", "bold");
      doc.text("SJO375592", 14, 45);

      doc.setFont(undefined, "", "bold");
      doc.text("Address:", 14, 55);
      doc.setFont(undefined, "", "normal");
      doc.text("9950 NW 17th St.", 42, 55);

      doc.setFont(undefined, "", "bold");
      doc.text("City/state:", 14, 65);
      doc.setFont(undefined, "", "normal");
      doc.text("Doral, Florida", 43, 65);
      doc.setFont(undefined, "", "bold");

      doc.text("Zip Code:", 14, 75);
      doc.setFont(undefined, "", "normal");
      doc.text("33172", 42, 75);
      doc.setFont(undefined, "", "bold");
      doc.text("Tel:", 65, 75);
      doc.setFont(undefined, "", "normal");
      doc.text("+1 305-592-5534", 80, 75);

      doc.line(14, 85, pageWidth-14, 85);
      doc.setFont(undefined, "", "bold");
      doc.text("Packages", 14, 95);
      doc.line(14, 102, pageWidth-14, 102);

      autoTable(doc, { 
        // margin: { top: 115 },
        startY: 110,
        theme: "grid",
        styles: {
          fontSize: 12,
        },
        headStyles :{ 
          fillColor : [32, 69, 112],
        },
        columnStyles: { 
          1: { halign: 'center' }, 
          3: { halign: 'center' } 
        }, 
        html: '.vs-table' }
      )

      doc.autoPrint({variant: 'non-conform'});
      doc.save('Orde-'+this.dispatchId+'.pdf')
      // doc.autoPrint();
      // doc.output('dataurlnewwindow');

    },
    closedModaSendReport(){
      this.activeSendReport = false
      this.buttonsHidden = false
      this.sendEmail = ''
      this.sendCC = ""
    },
    confirmToSent(){
        const that = this
        that.buttonsHidden = true
        InventoryService.sendReportByEmail({
          id: this.dispatchId,
          emailreport: this.sendEmail,
          cc: this.sendCC
        })
        .then(() => {
            that.activeSendReport = false
            that.buttonsHidden = false
            that.sendEmail = ''
            that.sendCC = ""
            that.$vs.loading.close('#btnDownloadPacks .con-vs-loading')
            that.updateMultiplePacks = []
      //      that.retrievePackages()
            that.$vs.notify({title:'Información!',text:'El documento fue enviado exitosamente!',color:'success',icon:'check'})
            
        })
        .catch(e => {
            console.log(e)
            that.buttonsHidden = false
            that.$vs.notify({title:'Información!',text:'Error enviado el documento!',color:'danger',icon:'error_outline'})                
        });
    },
    
    downloadPackagesReport() {
        this.loadingProgress ('#btnDownloadPacks', '#1f74ff')
        InventoryService.downloadOrdersToProvider({ id: this.dispatchId })
        .then(response => {
            let blob = new Blob([response.data], { type: "application/vnd.ms-excel" }); 
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "Order-" + this.dispatchId+ "-packages.xlsx";
            a.click();
            window.URL.revokeObjectURL(url)
            this.$vs.loading.close('#btnDownloadPacks .con-vs-loading')
            this.$vs.notify({title:'Información!',text:'La descarga de los paquetes ha iniciado!',color:'success',icon:'check'})
            
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.confirmStatus = false
            this.$vs.notify({title:'Información!',text:'Error descargado los paquetes!',color:'danger',icon:'error_outline'})                
        });
    },
    getDispatchDetail(id) {
        InventoryService.getDispatchDetail(id)
        .then(response => {
            this.dispatchId = this.$route.params.id
            this.dispatchOrden = response.data.records
            this.pkgCurrentStatus = { code: this.dispatchOrden.st01Code, name: this.dispatchOrden.statusName }
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo la orden de despacho!',color:'danger',icon:'error_outline'})
        });
        this.$Progress.finish()
    },

    handleActionModalPackage(response){
      if(response.error !=  undefined){
        if(!response.error){
            this.dispatchOrden.st01Code = response.response.code;
            this.dispatchOrden.statusName = response.response.name;
            this.pkgCurrentStatus = { code: response.response.code, name: response.response.name }

          this.$vs.notify({title:'Información!',text:'El estado del paquete fue modificado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el estado del paquete',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActive = response.active      
    },

    changeDispatchStatus(){
      // if(this.userInfoData.role != 'Customer'){
      //   this.packageId    = value
      //   this.typeChangeSt = type != 'single' ? true : false;
      //   type != 'single' ? true : false;
      //   if(type == 'single'){
      //     this.pkgCurrentStatus = this.currentPackStatus(value)
      //   }
        this.packageId = this.dispatchOrden.id.toString();
        this.modalActive = true

      // }
    },

  }
}
</script>
